"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputBox = exports.getBGView = exports.getBorderView = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const ControlSeparator_1 = require("../ControlSeparator");
const helpers_1 = require("../../helpers");
const styles_1 = require("../../helpers/styles");
const Icon_1 = require("../../Icon");
const StackView_1 = require("../../StackView");
const View_1 = require("../../View");
const HEIGHT_ROW = 30;
const HEIGHT_COMPACT_ROW = 22;
const getBorderView = ({ hasError, isActive, isFocused, isDisabled }) => {
    if (isDisabled) {
        return View_1.VIEW_BORDER.disabled;
    }
    if (hasError) {
        return View_1.VIEW_BORDER.error;
    }
    if (isActive || isFocused) {
        return View_1.VIEW_BORDER.brand;
    }
    return View_1.VIEW_BORDER.normal;
};
exports.getBorderView = getBorderView;
const getBGView = ({ hasError, partialError, isDisabled }) => {
    if (partialError) {
        return View_1.VIEW_BG_VIEW.normal;
    }
    if (isDisabled) {
        return View_1.VIEW_BG_VIEW.disabled;
    }
    if (hasError) {
        return View_1.VIEW_BG_VIEW.error;
    }
    return View_1.VIEW_BG_VIEW.normal;
};
exports.getBGView = getBGView;
const activeStyle = ({ hasError }) => (0, styled_components_1.css) `
    ${({ theme }) => (0, styled_components_1.css) `
        background: ${hasError
    ? theme.colors.backgrounds.highlightErrorDark
    : theme.colors.backgrounds.highlightDark};
        &:hover {
            background: ${hasError
    ? theme.colors.backgrounds.highlightErrorDark
    : theme.colors.backgrounds.highlightDark};
        }
    `}
`;
const ActionButton = (0, styled_components_1.default)((_a) => {
    var { className, action: { testId, icon, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onClick }, disabled, hasError, targetRef } = _a, rest = __rest(_a, ["className", "action", "disabled", "hasError", "targetRef"]);
    return (react_1.default.createElement("button", { className: className, disabled: disabled, "data-selector-id": testId, tabIndex: -1, onFocus: (e) => {
            e.stopPropagation();
            e.preventDefault();
        }, onMouseDown: (e) => {
            var _a;
            e.stopPropagation();
            (_a = rest.onMouseDown) === null || _a === void 0 ? void 0 : _a.call(rest);
            if (!disabled) {
                setTimeout(() => {
                    var _a;
                    (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 0);
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown();
            }
        }, onMouseUp: () => {
            if (!disabled) {
                onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp();
            }
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: (e) => {
            e.stopPropagation();
            if (!disabled) {
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }
        } },
        react_1.default.createElement(Icon_1.Icon, { src: icon, disabled: disabled, error: hasError })));
}) `
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    outline: 0;
    margin: 0;
    padding: 0;
    width: calc(${helpers_1.SPACING_XL} - 2 * ${helpers_1.BASE_BORDER_WIDTH});
    background: transparent;

    ${({ theme, disabled, hasError, active }) => !disabled &&
    (0, styled_components_1.css) `
            &:focus,
            &:hover {
                background: ${hasError
        ? theme.colorHighlightErrorLight
        : theme.colorHighlightLight};
            }

            &:active {
                ${activeStyle}
            }

            ${active && activeStyle}
        `}
`;
const Root = (0, styled_components_1.default)(View_1.View) `
    overflow: hidden;
    outline: none;
    ${({ isCompact }) => {
    if (isCompact) {
        return (0, styled_components_1.css) `
                min-height: ${HEIGHT_COMPACT_ROW}px;
            `;
    }
    return (0, styled_components_1.css) `
            min-height: ${helpers_1.SPACING_XL};
            height: ${helpers_1.SPACING_XL};
        `;
}}
    ${({ rows }) => rows &&
    (0, styled_components_1.css) `
            height: ${HEIGHT_ROW * rows}px;
        `}
    ${({ maxRows, isCompact }) => maxRows &&
    (0, styled_components_1.css) `
            height: auto;
            max-height: ${isCompact
        ? `calc(${HEIGHT_ROW * maxRows}px - ${helpers_1.SPACING_S})`
        : `calc(${HEIGHT_ROW * maxRows}px + 2 * ${helpers_1.BASE_BORDER_WIDTH})`};
        `}
    ${({ buildIn, isCompact }) => {
    if (buildIn && isCompact) {
        return (0, styled_components_1.css) `
                border-color: transparent;
            `;
    }
    if (buildIn) {
        return (0, styled_components_1.css) `
                border-color: transparent;
                margin: -1px -1px -1px 0;
            `;
    }
    return (0, styled_components_1.css) ``;
}}
    ${({ buildIn, isCompact, highlighted, disabled, theme }) => !disabled &&
    buildIn &&
    !isCompact &&
    !highlighted &&
    (0, styled_components_1.css) `
            &:hover {
                background: ${theme === null || theme === void 0 ? void 0 : theme.colorHighlightLight};
            }
        `}
    ${({ buildIn, highlighted, disabled, theme }) => buildIn &&
    highlighted &&
    !disabled &&
    (0, styled_components_1.css) `
            background: ${theme === null || theme === void 0 ? void 0 : theme.colorHighlightDark};
        `}
`;
const Inner = (0, styled_components_1.default)(StackView_1.StackView) `
    height: 100%;

    ${({ isCompact }) => {
    if (isCompact) {
        return (0, styled_components_1.css) `
                min-height: calc(${HEIGHT_COMPACT_ROW}px);
            `;
    }
    return (0, styled_components_1.css) `
            min-height: calc(${HEIGHT_ROW}px - 2 * ${helpers_1.BASE_BORDER_WIDTH});
        `;
}}

    ${({ maxRows, isCompact }) => maxRows &&
    (0, styled_components_1.css) `
            max-height: ${isCompact
        ? `calc(${maxRows} * ${HEIGHT_ROW}px - ${helpers_1.SPACING_S})`
        : `calc(${maxRows} * ${HEIGHT_ROW}px)`};
        `}
`;
const Separator = (0, styled_components_1.default)(ControlSeparator_1.ControlSeparator) `
    align-self: center;
`;
exports.InputBox = (0, helpers_1.createUIElement)('InputBox', (_a, ref) => {
    var _b;
    var { className, hasError = false, partialError = false, isDisabled = false, isActive = false, isFocused = false, tabIndex, highlighted, performed, size, scrollableRef, testId, children, actions, hasSpacing = true, buildIn, rows, maxRows, rightAddon, hasRightAddonSeparator, isCompact = false, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "hasError", "partialError", "isDisabled", "isActive", "isFocused", "tabIndex", "highlighted", "performed", "size", "scrollableRef", "testId", "children", "actions", "hasSpacing", "buildIn", "rows", "maxRows", "rightAddon", "hasRightAddonSeparator", "isCompact", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const preventBlurFlagRef = (0, react_1.useRef)(false);
    const _ref = (0, react_1.useRef)(null);
    ref = ref || _ref;
    const preventBlur = () => {
        preventBlurFlagRef.current = true;
    };
    return (react_1.default.createElement(Root, Object.assign({}, rest, { "data-selector-id": testId || rest['data-selector-id'], className: `vm-InputBox ${className}`, buildIn: buildIn, tabIndex: tabIndex || 0, highlighted: highlighted, performed: performed, disabled: isDisabled, isCompact: isCompact, "data-state-performed": performed ? true : undefined, "data-state-disabled": isDisabled ? true : undefined, "data-state-focused": isFocused ? true : undefined, "data-state-active": isActive ? true : undefined, borderAll: isCompact
            ? undefined
            : (0, exports.getBorderView)({ hasError, isActive, isFocused, isDisabled }), backgroundView: (0, exports.getBGView)({
            hasError,
            partialError,
            isDisabled
        }), contentMod: View_1.VIEW_CONTENT_MOD.fill, rows: rows, maxRows: maxRows, size: { width: typeof size === 'string' ? size : (0, styles_1.calcWidth)(size) }, onFocus: onFocus, onBlur: (e) => {
            if (preventBlurFlagRef.current) {
                preventBlurFlagRef.current = false;
                e.stopPropagation();
                e.preventDefault();
                return;
            }
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        }, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Inner, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.fill, distribution: StackView_1.STACK_DISTRIBUTION.firstFill, maxRows: maxRows, isCompact: isCompact },
            react_1.default.createElement(View_1.View, { ref: scrollableRef, clipped: true, hasYScroll: !!maxRows, spaceHorizontal: hasSpacing ? View_1.INDENT.s : undefined, contentMod: View_1.VIEW_CONTENT_MOD.fill, backgroundView: performed && !isDisabled ? View_1.VIEW_BG_VIEW.highlight : undefined }, children),
            !!((_b = actions === null || actions === void 0 ? void 0 : actions.filter(Boolean)) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.fill, direction: StackView_1.STACK_DIRECTION.row },
                !!actions[0] && (react_1.default.createElement(ActionButton, { key: 0, targetRef: ref, action: actions[0], disabled: isDisabled, hasError: hasError, active: actions[0].active, onMouseDown: preventBlur })),
                !!actions[0] && !!actions[1] && react_1.default.createElement(Separator, null),
                !!actions[1] && (react_1.default.createElement(ActionButton, { key: 1, targetRef: ref, action: actions[1], disabled: isDisabled, hasError: hasError, active: actions[1].active, onMouseDown: preventBlur })))),
            rightAddon && hasRightAddonSeparator && react_1.default.createElement(Separator, null),
            rightAddon && react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.fill }, rightAddon))));
});
//# sourceMappingURL=InputBox.js.map